<template>
    <div>
        <b-row>
            <b-col cols="0" sm="3"	md="4"	lg="4"	xl="4"></b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                <div class="col-md-12 text-center">
                    <b-button variant="secondary" @click="listNotaVenta"><i class="fa fa-sync-alt"></i> </b-button>
                </div>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2"></b-col>
            <b-col md="2">
                <b-form-group horizontal label="Mostrar">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listNotaVenta">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
            </b-col>
        </b-row><br>
        <b-row>
            <b-col>
                <b-table
                    responsive
                    outlined
                    small
                    striped
                    :busy="isBusy"
                    :items="listaNv"
                    :fields="lista_Nv">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                    <template slot="documento" slot-scope="row">
                        {{row.item.serie}} - {{ row.item.numero }}
                    </template>
                    <template slot="emision" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.notaVenta.receptor">
                            {{row.item.notaVenta.receptor.nro}} - {{row.item.notaVenta.receptor.razonSocial}}
                        </template>
                    </template>
                    <template slot="montoTotal" slot-scope="row">
                        <template v-if="row.item.notaVenta.moneda && row.item.notaVenta.totales.importeTotal">
                            {{row.item.notaVenta.moneda.simbolo}} {{parseFloat(row.item.notaVenta.totales.importeTotal).toFixed(2)}}
                        </template>
                    </template>
                    <template slot="pagado" slot-scope="row">
                        <template v-if="row.item.estado == '1'">
                           <b-badge variant="success" >Pagado</b-badge>
                        </template>
                        <template v-if="row.item.estado == '2'">
                           <b-badge variant="dark">Baja <i class="fas fa-ban"></i></b-badge>
                        </template>
                    </template>
                    <template slot="usuario" slot-scope="row">
                        <template v-if="row.item.notaVenta && row.item.notaVenta.adicional && row.item.notaVenta.adicional.username !=''">
                            {{row.item.notaVenta.adicional.username}}
                        </template>                      
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <template v-if="row.item.estado == '1'">
                            <b-button-group>
                                <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                                    <template v-if="!row.detailsShowing">
                                        <i class="fa fa-plus"></i>
                                    
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-minus"></i>
                                    </template>
                                </button>
                                <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="pdfNotaVenta(row)"><i class="fa fa-tv" title="Ver Nota de Venta"></i></b-button>
                                <b-button size="sm" v-b-tooltip.hover v-b-modal.sendnotaventaemail variant="secondary" @click="dataSendMail(row.item)"><i class="fa fa-envelope" title="Enviar por Correo"></i></b-button>
                                <b-button size="sm" v-b-modal.modal-center variant="success" title="convertir a Nota Venta" @click="clonarNV(row.item)"><i class="fa fa-1x fa-copy"></i></b-button>
                                <b-button size="sm" variant="danger" title="Baja Nota Venta" @click="modalbaja(row)"><i class="fas fa-trash-alt"></i></b-button>
                            </b-button-group>
                        </template>
                        <template v-if="row.item.estado == '2'">
                            
                        </template>
                    </template>
                    <!-- SUB ITEMSS -->
                    <template v-slot:row-details="row">
                        <b-card>
                            <b-table
                            head-variant="light"
                            :outlined="outlined"
                            responsive
                            striped
                            hover
                            :items="row.item.notaVenta.items"
                            :fields="listaitems_fields"
                            :busy="row.item.loading"
                            >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="cantidad" slot-scope="row">
                                <div>
                                    <template v-if="row.item.cantidad">
                                        {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                                </div>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                {{ parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.valorVenta"
                                >{{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}</template>
                                    <div style="float:right;color:red">
                                        {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                                    </div>
                                </div>
                            </template>
                            </b-table>
                            <label v-if="row.item.notaVenta.observaciones != null" style="color:red">observaciones: </label> {{row.item.notaVenta.observaciones}} 
                            <label v-if="row.item.notaVenta.atencion != null" style="color:red">Atencion: </label> {{row.item.notaVenta.atencion}} 
                            <label v-if="row.item.notaVenta.plazoentrega != null" style="color:red">Plazo Entrega: </label> {{row.item.notaVenta.plazoentrega}} 
                            <label v-if="row.item.notaVenta.formapago != null" style="color:red">Forma de Pago: </label> {{row.item.notaVenta.formapago}} 
                            <label v-if="row.item.notaVenta.garantia != null" style="color:red">Garantia: </label> {{row.item.notaVenta.garantia}} 
                            <label v-if="row.item.notaVenta.telefono != null" style="color:red">Telefono: </label> {{row.item.notaVenta.telefono}}
                        </b-card>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="10">
                        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </b-col>
                    <b-col cols="12" sm="8"	md="6"	lg="4"	xl="2">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listNotaVenta"></b-pagination>
                    </b-col>
                </b-row>
                <!-- PDF -->
                <b-modal id="pdfnotaventa" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="pdfnotaventa">
                    <template v-if="cargandopdfnv"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                    <template v-else>
                    <template v-if="pdfobject !==''">
                        <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                    </template>
                    </template>
                </b-modal>
                <!-- EMAIL -->
                <b-modal id="sendnotaventaemail" title="Enviar por Correo" v-model="previacorreo">
                    <div role="group">
                        <label for="inputLive">Correos:</label>
                        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail()"></b-form-input>
                        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
                    </div>
                    <div slot="modal-footer" class="w-100">
                        <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail()">
                            Enviar
                        </b-btn>
                        <b-btn v-else size="sm" class="float-right" variant="secondary">
                            <i class="fa fa-spin fa-spinner"></i> Enviando...
                        </b-btn>
                    </div>
                </b-modal>
                <b-modal id="modal-center" centered title="Nota de Venta" v-model="clonarNotaVenta">
                    <p class="my-4">Esta a punto de convertir una nueva <b>Nota de Venta</b> con los items de la Nota de Venta seleccionada.</p>
                    <template slot="modal-footer" >
                        <div>
                            <b-button variant="primary" @click="enviarnuevaNotaVenta">Continuar</b-button>
                        </div>             
                    </template>
                </b-modal>
                <b-modal centered title="Nota de Venta - Baja" v-model="mostrarmodalbaja">
                    <div v-if="datosbaja && datosbaja.item && datosbaja.item.serie != ''">
                        <h5>{{datosbaja.item.notaVenta.adicional.username}}</h5>
                        <br> ¿Desea dar de Baja a la siguiente Nota de Venta?
                       <div class="text-center">
                           <b-card><b>Documento:</b> {{datosbaja.item.notaVenta.receptor.nro}} - {{datosbaja.item.notaVenta.receptor.razonSocial}}  <b>{{datosbaja.item.serie}} - {{datosbaja.item.numero}}</b></b-card>
                       </div>
                    </div>     
                    <template slot="modal-footer" >
                        <div v-if="!cargandoBajaNV">
                            <b-button variant="danger" @click="bajaNotaVenta(datosbaja)">Continuar</b-button>
                        </div>
                        <div v-else>
                            <b-button variant="danger" disabled>Cargando Baja <b-spinner class="align-middle"></b-spinner></b-button>
                        </div>           
                    </template>
                </b-modal>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name:'notaVentaConsulta',
    data() {
        return {
            limite: 10,
            currentPage: 1,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            listaNv:[],
            lista_Nv: [
                {key: 'documento', label: 'Documento', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'montoTotal', label: 'Monto Total', sorteable: true},
                {key: 'usuario', label: 'Usuario', sorteable: true},
                {key: 'pagado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            outlined:true,
            fixed:true,
            listaitems_fields: [
                { key: "index" },
                { key: "codigoProducto", label: "Codigo", sorteable: true },
                { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                { key: "descripcion", label: "Descripción", sorteable: true },
                { key: "observacion", label: "Observación", sorteable: true },
                { key: "cantidad", label: "Cantidad", sorteable: true },
                { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                { key: "descuento", label: "Descuento", sorteable: true },
                { key: "valorVenta", label: "Precio Total", sorteable: true }
            ],
            pdfnotaventa: false,
            cargandopdfnv: false,
            pdfobject: null,
            previacorreo: false,
            notaventa:{},
            sendcorreo: false,
            recipients:'',
            bajaNV:'2',
            isBusy: false,
            clonarNotaVenta:false,
            nuevosItems:[],
            mostrarmodalbaja:false,
            datosbaja :{},
            cargandoBajaNV: false,
        }
    },
    mounted(){
        this.listNotaVenta();
        this.initReturn();
    },
    methods:{
        listNotaVenta(){
            this.isBusy = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notaventa/listar',{
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
            })
            .then(response=>(
                this.isBusy = false,
                this.listaNv = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log(error.response.data.msg),
                this.isBusy = false
            ))
        },
        pdfNotaVenta: function (row) {
            this.pdfnotaventa = true,
            this.pdfobject = '',
            this.cargandopdfnv = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notaventa/pdf', {
                token: this.$store.getters.userToken,
                id: row.item.idNotaVenta
            })
            .then(response => (
                this.pdfobject = response.data.pdf,
                this.cargandopdfnv = false
            ))
            .catch(error => {
                this.cargandopdfnv = false,
                this.$snotify.error(error.response.data.msg,'Error')
            })
        },
        dataSendMail: function (data) {
            this.notaventa = data
        },
        sendMail: function () {
            this.previacorreo = true,
            this.sendcorreo = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'notaventa/pdf/mail', {
                token: this.$store.getters.userToken,
                id: this.notaventa.idNotaVenta,
                mail: this.recipients
            })
            .then(response => (
                this.sendcorreo = false,
                this.previacorreo = false,
                this.$snotify.success(response.data.msg, 'Exito')
            ))
            .catch(error => (
                this.previacorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        bajaNotaVenta(value){
            this.cargandoBajaNV = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'notaventa/actualizar',{
                token: this.$store.getters.userToken,
                id: value.item.idNotaVenta,
                notaVenta: value.item.notaVenta,
                estado:this.bajaNV 
            })
            .then(response=>(
                this.$bvToast.toast("Solicitud de baja enviada correctamente", {
                    title: "Éxito",
                    variant: "success",
                    solid: true
                }),
                this.cargandoBajaNV = false,
                this.listNotaVenta(),
                this.mostrarmodalbaja = false
            ))
            .catch(error=>(
                this.$bvToast.toast("Error al enviar la solicitud de baja", {
                    title: "Error",
                    variant: "danger",
                    solid: true
                }),
                this.cargandoBajaNV = false
            ))
        },
        clonarNV(value){
            this.nuevosItems = value;
        },
        enviarnuevaNotaVenta(){
            this.changeTab(6);
            this.nuevaNotaVentaClonada(this.nuevosItems);
        },
         changeTab: function (value){
            this.$emit("tabindex", value);
        },
        nuevaNotaVentaClonada: function (value){
            this.$emit("nuevaNotaVentaClonada", value);
        },
        initReturn: function () {
                let proformaBlank = {}
                this.nuevaNotaVentaClonada(proformaBlank)
        },
        modalbaja(value){
            this.mostrarmodalbaja = true;
            this.datosbaja = value;
        }
    }
}
</script>
<style scoped>

</style>